export default __webpack_public_path__ + "static/media/kedarnath3.1ed41cb8.jpg";